import styled from 'styled-components'

export const MainContainer = styled.div`
  height: 100vh;
  display: flex;
  @media screen and (max-width: 767px) {
    flex-direction: column;
  }
`
export const CreditCardContainer = styled.div`
  width: 50%;
  background-color: #3b4b69;
  padding: 40px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media screen and (max-width: 767px) {
    width: 100%;
  }
`
export const PaymentMethodContainer = styled.div`
  width: 50%;
  padding: 40px 20px;
  @media screen and (max-width: 767px) {
    width: 100%;
  }
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`
export const Heading = styled.h1`
  font-size: 30px;
  font-family: 'Roboto';
  font-weight: bold;
  color: #ffffff;
  padding-bottom: 10px;
  border-bottom: 5px solid #ffd773;
`
export const CreditCardItem = styled.div`
  background-image: url('https://assets.ccbp.in/frontend/hooks/credit-card-bg.png');
  background-size: cover;
  height: 250px;
  padding: 40px;
  width: 100%;
  border-radius: 20px;
  margin: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
`
export const CardNumber = styled.p`
  font-size: 30px;
  color: #ffffff;
  margin-top: 50px;
`
export const NameLabel = styled.p`
  font-size: 14px;
  font-family: 'Roboto';
  font-weight: 500;
  color: #ffffff;
  margin-bottom: 0px;
`
export const CardHolderName = styled.p`
  font-size: 20px;
  font-family: 'Roboto';
  font-weight: 900;
  color: #ffffff;
`
export const PaymentMethodCard = styled.div`
  background-color: #ffffff;
  border-radius: 20px;
  width: 100%;
  padding: 20px;
  box-shadow: 0px 4px 10px 0px #475569;
  display: flex;
  flex-direction: column;
  align-items: center;
`
export const Input = styled.input`
  outline: none;
  width: 100%;
  padding: 10px 20px;
  margin-bottom: 30px;
  border: 2px solid #d3d9e0;
  border-radius: 4px;
`
export const PaymentHeaing = styled.h1`
  color: #475569;
  font-size: 20px;
  font-family: 'Roboto';
  font-weight: 900;
`
